<nz-skeleton
  [nzActive]="true"
  [nzLoading]="true"
  *ngIf="loaderMatches"
  class="py-5 max-sm:py-3"
>
</nz-skeleton>

<ng-container *ngIf="!loaderMatches && dashboardToday.length > 0">
  <app-scores-football-team
    [dashboardSport]="{
      date: dateSelected,
      filter: 'All',
      today: true,
      dashboard: dashboardToday
    }"
    *ngIf="
      hasFavoriteSport
        ? hasFavoriteSport === 'Futbol'
        : this.sportsServices.getSelectedSport() === 'Futbol'
    "
  >
  </app-scores-football-team>
  <app-scores-sports-team
    [dashboardSport]="{
      date: dateSelected,
      filter: 'All',
      today: true,
      dashboard: dashboardToday
    }"
    *ngIf="
      hasFavoriteSport
        ? hasFavoriteSport !== 'Futbol'
        : this.sportsServices.getSelectedSport() !== 'Futbol'
    "
    [hasFavoriteSport]="hasFavoriteSport ? hasFavoriteSport : null"
  ></app-scores-sports-team>
</ng-container>
<app-no-result
  *ngIf="!loaderMatches && dashboardToday.length === 0"
></app-no-result>
